import { storageKeys } from '@selfserve/react-hooks';

import { partnerStatusesTexts, subscriptionStatusesTexts } from '../constants/status-texts';
import { IBeFilter } from '../types';

const statuses = [...Object.keys(subscriptionStatusesTexts), ...Object.keys(partnerStatusesTexts)];

const products = ['VPAAS', 'KMS', 'KME', 'KMC', 'EP'];

export const getAdminSearchValue =
    (setState: (beSearch: null | IBeFilter) => void) =>
        (value: string): boolean => {
            if (!value) {
                setState(null);
                return false;
            } else {
                let productFamilies = [];
                try {
                    productFamilies = JSON.parse(
                        sessionStorage.getItem(storageKeys.PRODUCT_FAMILIES) || ''
                    );
                } catch { }
                const status = statuses.find(status => status.toLowerCase() === String(value).toLowerCase());
                const product = products.find(product => product.toLowerCase() === String(value).toLowerCase());
                const productFamily = productFamilies.find(
                    (productFamily: string) => productFamily.toLowerCase() === String(value).toLowerCase()
                );
                if (status) {
                    setState({ status });
                    return true;
                }
                if (+value) {
                    setState({ partnerId: String(value) });
                    return true;
                }
                if (product) {
                    setState({ product });
                    return true;
                }
                if (productFamily) {
                    setState({ productFamily });
                    return true;
                }
                setState(null);
                return false;
            }
        };
